<template>
  <div class=''>
    <div id="chart"></div>
  </div>
</template>

<script>
import echarts from "echarts";
export default {
  name: "",
  props: {
    warnList: {
      type: Array,
      default: function() {
        return [];
      }
		},
		xdata: {
      type: Array,
      default: function() {
        return [];
      }
    },
    chartParam: {
      type: Object,
      default: function() {
        return {};
      }
    },
    dataList: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  watch: {
    dataList: {
      handler: function(newValue, oldValue) {
				
        this.setOptions();
      },
      deep: true
    }
  },
  components: {},
  created() {},
  mounted() {},
  methods: {
    initChart() {
      this.chart = echarts.init(document.getElementById("chart"));
    },
    setOptions() {
			var that = this;
      if (this.chart) {
        this.chart.clear();
      } else {
        this.chart = echarts.init(document.getElementById("chart"));
      }
      var areaStyle = {
        silent: true,
        label: {
          position: [20, 20],
          color: "#53A58A",
          fontSize: 14,
          fontWeight: "bold"
        },
        data: [
          [
            {
              yAxis: this.warnList[0],
              itemStyle: {
                color: "rgba(249,184,63,0.2)"
              },
              label: {
                normal: {
                  offset: [500, 500],

                  fontSize: 14
                }
              }
            },
            {
              yAxis: this.warnList[3]
            }
          ],
          [
            {
              yAxis: this.warnList[1],
              itemStyle: {
                color: "rgba(20,207,186,0.2)"
              },
              label: {
                normal: {
                  offset: [500, 500],

                  fontSize: 14
                }
              }
            },
            {
              yAxis: this.warnList[2]
            }
          ]
        ]
      };
      let option = {
        title: {
          text: this.chartParam.aliasName,
          left: "5%",
          textStyle: {
            color: "#fff",
            fontSize: 14
          }
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          icon: "rect",
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 13,
          right: 15,
          top: 0,
          data: [""]
        },
        color: ["#f9b83f"],
        grid: {
          left: "6%",
          right: "2%",
          top: "10%",
          bottom: "13%",
          containLabel: true
        },
        xAxis: {
          show: true,
          type: "category",
          splitLine: {
            show: false
          },
          data: that.xdata,
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: "#ddd"
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#666", //纵向网格线颜色
              width: 1,
              type: "dashed"
            }
          }
        },
        yAxis: {
          // name: this.chartParam.aliasName,
          type: "value",
          splitLine: {
            show: true,
            lineStyle: {
              color: "#666", //纵向网格线颜色
              width: 1,
              type: "dashed"
            }
          },
          axisLabel: {
            color: "#999"
          },
          axisLine: {
            lineStyle: {
              color: "#6db7d1"
            }
          },
          axisTick: {
            show: false
          }
        },
        series: [
          {
            name: "生理上限 ",
            type: "line",
            markArea: areaStyle,
            color: "#666",
            data: [this.warnList[0]],
            lineStyle: {
              color: "#666",
              width: 5
            },
            markLine: {
              itemStyle: {
                normal: {
                  lineStyle: {
                    color: "#666"
                  },
                  label: {
                    show: true
                  }
                }
              },
              data: [
                {
                  type: "average",
                  name: "生理上限"
                }
              ],
              areaStyle: {
                origin: "start"
              }
            }
          },
          {
            name: "生理下限",
            type: "line",
            color: "#666",
            data: [this.warnList[3]],
            markLine: {
              itemStyle: {
                normal: {
                  lineStyle: {
                    color: "#666"
                  },
                  label: {
                    show: true
                  }
                }
              },
              data: [
                {
                  type: "average",
                  name: "生理下限",
                  color: "#666"
                }
              ]
            }
          },
          {
            name: "适宜上限",
            color: "#16c18c",
            type: "line",
            data: [this.warnList[1]],
            markLine: {
              itemStyle: {
                normal: {
                  lineStyle: {
                    color: "#16c18c"
                  },
                  label: {
                    show: true
                  }
                }
              },
              data: [
                {
                  type: "average",
                  name: "适宜上限"
                }
              ]
            }
          },
          {
            name: "适宜下限",
            type: "line",
            color: "#16c18c",
            data: [this.warnList[2]],
            //  yAxis: 3.03,
            // label: {
            //     formatter: '正常范围'
            // },
            markLine: {
              itemStyle: {
                normal: {
                  lineStyle: {
                    color: "#16c18c"
                  },
                  label: {
                    show: true
                  }
                }
              },
              data: [
                {
                  type: "average",
                  name: "适宜下限"
                }
              ]
            }
          },
          {
            name: this.chartParam.aliasName,
            type: "line",
            symbol: "circle",
            lineStyle: {
              normal: {
                width: 2,
                shadowOffsetY: 4,
                shadowBlur: 4,
                shadowColor: "rgba(0,0,0,.08)"
              }
            },
            itemStyle: {
              normal: {
                borderColor: "#fff",
                borderWidth: 2,
                shadowOffsetY: 1,
                shadowBlur: 5,
                shadowColor: "rgba(19,138,255,.21)"
              }
            },
            smooth: true,
            data: that.dataList,
            markPoint: {
              symbolSize: ["36", "22"],
              symbolOffset: ["0", "-90%"],
              label: {
                normal: {
                  offset: [0, -3]
                }
              }
            }
          }
        ]
      };
      this.chart.setOption(option);
      window.onresize = this.chart.resize;
    }
  }
};
</script>
<style lang='scss' scoped>
#chart {
  height: 340px;
  width: 100%;
}
</style>
